<template>
  <div
    :class="[
      ns.b(),
      { [ns.m('border')]: border },
      { [ns.is('auto-height')]: autoHeightMode },
      { [ns.is('fill')]: fillMode },
      gridSizeClass,
    ]"
  >
    <grid-toolbar v-if="showToolbar" />
    <grid-filter-summary v-if="showToolbar" />
    <div :class="ns.e('main')">
      <div :class="ns.e('body-row')">
        <div :class="ns.e('body-main')">
          <grid-body />
          <grid-loading
            :visible="reactData.loading || reactData.loadError"
            :loading="reactData.loading"
            :error="reactData.loadError"
            :error-message="reactData.loadErrorMsg"
          />
        </div>
      </div>
    </div>
    <div :class="[ns.e('pagination'), { [ns.is('total-only')]: infiniteScrollEnabled }]">
      <z-pagination
        v-model:current-page="reactData.currentPage"
        v-model:page-size="reactData.pageSize"
        :page-sizes="reactData.pageSizes"
        :total="reactData.total"
        :size="gridSize"
        :layout="paginationLayout"
        :background="!infiniteScrollEnabled"
        @current-change="onPageChange"
        @size-change="onPageChange"
      />
      <span v-if="reactData.loadingMore" :class="ns.e('loading-more')">
        {{ t('z.table.loadingText') }}
      </span>
    </div>
    <grid-filters />
    <export-panel v-if="reactData.initStore.export" />
    <column-menu v-if="reactData.initStore.columnMenu" />
    <grid-context-menu v-if="reactData.initStore.contextMenu" />
    <columns-tool-panel v-if="reactData.initStore.custom" />
    <grid-ai-panel v-if="reactData.initStore.aiAssistant" />
  </div>
</template>

<script setup lang="ts">
import { computed, inject } from 'vue'
import { useLocale, useNamespace } from '@zoryn/hooks'
import ZPagination from '@zoryn/components/pagination'
import GridToolbar from './toolbar.vue'
import GridFilterSummary from './filter-summary.vue'
import GridBody from './grid-body.vue'
import GridLoading from './loading.vue'
import GridFilters from './filters.vue'
import ExportPanel from './export-panel.vue'
import ColumnsToolPanel from './columns-tool-panel.vue'
import ColumnMenu from './column-menu.vue'
import GridContextMenu from './grid-context-menu.vue'
import GridAiPanel from './grid-ai-panel.vue'
import { isInfiniteScrollEnabled } from '../utils/infinite-scroll'
import type { DataGrid } from '../types'

const ns = useNamespace('grid')
const { t } = useLocale()
const $grid = inject('$grid') as DataGrid
const { reactData, options, props } = $grid

const border = computed(() => props.border !== false)
const showToolbar = computed(() => options.toolbar !== false)
const infiniteScrollEnabled = computed(() => isInfiniteScrollEnabled(options))
const paginationLayout = computed(() =>
  infiniteScrollEnabled.value
    ? 'total'
    : 'total, sizes, prev, pager, next, jumper'
)
const gridSize = computed(() => $grid.gridSize.value)
const gridSizeClass = computed(() => {
  const size = gridSize.value
  return size && size !== 'default' ? ns.m(size) : ''
})
const autoHeightMode = computed(
  () =>
    props.autoHeight !== false
    && (props.height == null || props.height === '')
)
/** autoHeight=false 且未传 height：表格区跟随父容器铺满，分页贴底 */
const fillMode = computed(
  () =>
    props.autoHeight === false
    && (props.height == null || props.height === '')
)

function onPageChange() {
  if (infiniteScrollEnabled.value) {
    return
  }
  void $grid.queryByExamplePage()
}
</script>
